function normalizeHeaderSearchTerm(value) {
	if (typeof value !== 'string') return '';
	return value
		.replace(/&(?:amp;)?quot;/gi, '"')
		.replace(/\u00A0/g, ' ')
		.replace(/&nbsp;?/gi, ' ')
		.trim();
}

function normalizeHeaderSearchTermForSubmit(value) {
	const normalized = normalizeHeaderSearchTerm(value);
	if (normalized === '') return '*';

	const numericTerm = normalized.match(/^"*(\d+)"*$/);
	return numericTerm ? numericTerm[1] : normalized;
}

document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('form[role="search"]').forEach(function (form) {
		const searchInput = form.querySelector('input[name="q"]');
		if (!searchInput) return;

		form.addEventListener('submit', function () {
			const normalizedTerm = normalizeHeaderSearchTermForSubmit(searchInput.value);
			const prefixInput = form.querySelector('input[name="options[prefix]"]');

			searchInput.value = normalizedTerm;
			if (prefixInput) {
				prefixInput.value = /^\d+$/.test(normalizedTerm) ? 'none' : 'last';
			}
		});
	});
});
